import {
  ClickAwayListener as MuiClickAwayListener,
  MenuList as MuiMenuList,
  Popper as MuiPopper,
  Paper as MuiPaper,
  Grow as MuiGrow,
  Box as MuiBox,
} from '@mui/material';
import { MuiMenuButton } from '../../../components';

export const PatientActionsMenu = ({
  open,
  anchorRef,
  onCloseMenu,
  handleListKeyDown,
  options,
  isActive,
}) => {
  return (
    <MuiPopper
      data-id="actions-button-menu"
      open={open}
      anchorEl={anchorRef.current}
      transition
      disablePortal
      role={undefined}
      style={{ zIndex: 2 }}
      placement={'left-start'}
    >
      {({ TransitionProps, placement }) => (
        <MuiGrow {...TransitionProps}>
          <MuiPaper>
            <MuiClickAwayListener onClickAway={onCloseMenu}>
              <MuiMenuList
                autoFocusItem={open}
                id="patient-actions"
                onKeyDown={handleListKeyDown}
              >
                <MuiBox display="grid" gap={1} padding="12px 0">
                  {options.map(({ label, icon, action, variant }) => (
                    <MuiMenuButton
                      disabled={icon === 'check-circle' ? isActive : !isActive}
                      data-id="menu-button"
                      id={label}
                      key={label}
                      label={label}
                      icon={icon}
                      action={action}
                      variant={variant}
                    />
                  ))}
                </MuiBox>
              </MuiMenuList>
            </MuiClickAwayListener>
          </MuiPaper>
        </MuiGrow>
      )}
    </MuiPopper>
  );
};
